// extracted by mini-css-extract-plugin
export var centered = "_redotech-redo-web-lib-modal-centered";
export var flexible = "_redotech-redo-web-lib-modal-flexible";
export var footer = "_redotech-redo-web-lib-modal-footer";
export var footerBorder = "_redotech-redo-web-lib-modal-footer-border";
export var header = "_redotech-redo-web-lib-modal-header";
export var headerBorder = "_redotech-redo-web-lib-modal-header-border";
export var headerDefault = "_redotech-redo-web-lib-modal-header-default";
export var headerMedium = "_redotech-redo-web-lib-modal-header-medium";
export var headerPadding = "_redotech-redo-web-lib-modal-header-padding";
export var iconAndTitle = "_redotech-redo-web-lib-modal-icon-and-title";
export var large = "_redotech-redo-web-lib-modal-large";
export var largePadding = "_redotech-redo-web-lib-modal-largePadding";
export var medium = "_redotech-redo-web-lib-modal-medium";
export var mediumPadding = "_redotech-redo-web-lib-modal-mediumPadding";
export var modal = "_redotech-redo-web-lib-modal-modal";
export var modalContainer = "_redotech-redo-web-lib-modal-modal-container";
export var noPadding = "_redotech-redo-web-lib-modal-no-padding";
export var skinny = "_redotech-redo-web-lib-modal-skinny";
export var small = "_redotech-redo-web-lib-modal-small";
export var smallPadding = "_redotech-redo-web-lib-modal-smallPadding";
export var subtitle = "_redotech-redo-web-lib-modal-subtitle";
export var title = "_redotech-redo-web-lib-modal-title";